/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {html} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {FacetBasic} from '../facet-basic/facet-basic';
import styles from './facet-diamond-shape.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class FacetDiamondShape extends FacetBasic {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	constructor () {
		super();
	}

	renderFacetValues () {
		const shapes = this.facet.values.filter(facetValue => !facetValue.title.includes('Signature'));
		const signatureShapes = this.facet.values.filter(facetValue => facetValue.title.includes('Signature'));
		const output = [];

		if (shapes?.length) {
			output.push(html`
				<div class="facet-values">
					${shapes.map(facetValue => html`
						<div class="facet--value">
							${this.renderFacetValue(facetValue)}
						</div>`)
					}
				</div>
			`);
		}

		if (signatureShapes?.length) {
			output.push(html`
				<div>Borsheims Signature Shapes</div>
				<div class="facet-signature-values">
					${signatureShapes.map(facetValue => html`
						<div class="facet--value">
							${this.renderFacetValue(facetValue)}
						</div>`)
					}
				</div>
			`);
		}

		return output;
	}

	/**
	 * @param {import('extensions/hawksearch/services/types').FacetValue} facetValue
	 */
	renderFacetValue (facetValue) {
		const classes = {
			'facet--value-active': facetValue.selected,
			'facet--value-link': true
		};

		return html`
			<a class="${classMap(classes)}" @click="${() => this.service.toggleFacetValue(this.facet.field, facetValue.value)}">
				<span class="facet-image ${this.getIcon(facetValue.value)}" aria-hidden="true"></span>
				<span class="facet-label">${facetValue.title}</span>
			</a>
		`;
	}

	/**
	 * @param {string} value
	 */
	getIcon (value) {
		const label = value?.toLowerCase()?.replace(/ /g, '-');

		switch (label) {
			case 'borsheims-signature-round':
				return `icon-diamond-round`;
			case 'borsheims-signature-oval':
				return `icon-diamond-oval`;
			case 'borsheims-signature-square':
				return `icon-diamond-cushion`;
			default:
				return `icon-diamond-${label}`;
		}
	}

};

defineCustomElement('rb-facet-diamond-shape', FacetDiamondShape);
